import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    budgets: [],
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getDashboard({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getDashboard(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getDashboardBO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getDashboardBO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.budget
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    parse({ commit }, payload) {
      commit(mutations.LOADING);
      return api.budget
        .parse(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    getHouse({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getHouse(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getEntity({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getEntity(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getOwner({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getOwner(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getBrand({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getBrand(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getTemplate({ commit }) {
      commit(mutations.LOADING);
      return api.budget
        .getTemplate()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getBudgetReport({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getBudgetReport(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getBudgetReportDetail({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getBudgetReportDetail(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getBudgetDetailTaxo({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.budget
        .getBudgetDetailTaxo(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {}
};
